export const actionTypes = {
  LOCK_SCROLL: 'LOCK_SCROLL',
  UNLOCK_SCROLL: 'UNLOCK_SCROLL',
}

export interface Action {
  type: string
}
